import { Injectable, NgZone, inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { io, Socket } from 'socket.io-client';

import {
  ProcessingFinishedEvent,
  VIBECODING_PROCESSING_FINISHED_EVENT,
  VIBECODING_PROCESSING_NAMESPACE,
  VIBECODING_PROCESSING_SOCKET_PATH,
} from '@plugins/vibecoding-lib/processing';

import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class ProcessingUpdatesService {
  private readonly dataService = inject(DataService);
  private readonly zone = inject(NgZone);

  private connectedInstanceId: string | null = null;
  private socket: Socket | null = null;

  connect(instanceId: string): void {
    if (this.connectedInstanceId === instanceId && this.socket) {
      return;
    }

    this.disconnect();

    this.connectedInstanceId = instanceId;
    this.socket = io(VIBECODING_PROCESSING_NAMESPACE, {
      path: VIBECODING_PROCESSING_SOCKET_PATH,
      query: { instanceId },
    });

    this.socket.on(
      VIBECODING_PROCESSING_FINISHED_EVENT,
      (event: ProcessingFinishedEvent) => {
        if (event.instanceId !== this.dataService.instance?.id) {
          return;
        }

        this.zone.run(() => {
          this.dataService
            .fetchInstance()
            .pipe(catchError(() => EMPTY))
            .subscribe();
        });
      },
    );
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
    this.connectedInstanceId = null;
  }
}
